






























































































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator';
import { BFormRow, BForm, BContainer, BRow, BCol, BButton, BIconCloudUpload, BIconTrash, BFormGroup, BFormInput, BFormInvalidFeedback, BFormSelect, BFormSelectOption, BFormTextarea, BIconCalendar, BInputGroup, BInputGroupAppend, BOverlay, BCard, BCardBody, BDropdown, BDropdownItemButton, BSpinner } from 'bootstrap-vue';
import Configuration from '@/types/Configuration';
import Validator, { handleValidationErrors } from '@/types/Validator';
import EntityReference from '@/types/EntityReference';
import DateTimePicker from '@/components/DateTimePicker.vue';
import DateTime from '@/types/DateTime';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-overlay': BOverlay,
        'b-card': BCard,
        'b-card-body': BCardBody,
        'b-form': BForm,
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-btn': BButton,
        'b-icon-cloud-upload': BIconCloudUpload,
        'b-icon-trash': BIconTrash,
        'b-form-group': BFormGroup,
        'b-input-group': BInputGroup,
        'b-input-group-append': BInputGroupAppend,
        'b-form-input': BFormInput,
        'b-form-invalid-feedback': BFormInvalidFeedback,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-form-textarea': BFormTextarea,
        'b-icon-calendar': BIconCalendar,
        'date-picker': DateTimePicker,
        'b-form-row': BFormRow,
        'b-dropdown': BDropdown,
        'b-dropdown-item-button': BDropdownItemButton,
        'b-spinner': BSpinner
    }
})
export default class PerformedWorkDetails extends Vue {
    @Prop() performedWorkId!: string;
    @Prop() action!: string;

    @Ref('pwDropdown') readonly pwDropdown!: BDropdown;
    @Ref('btnSaveAsNew') readonly btnSaveAsNew!: HTMLButtonElement;

    apiAccessToken = this.$store.state.apiAccessToken;
    isBusy = false;
    isBusySave = false;
    performedWorkDate: moment.Moment | undefined = DateTime.getCurrentDateTime(DateTime.formats.date).startOf('day').utcOffset(0, true);

    performedWork: PerformedWorkData = {
        id: null,
        sequenceId: 0,
        taskId: null,
        projectId: null,
        date: undefined,
        activity: null,
        identifier: null,
        duration: 0.5,
        isActive: true
    };

    tasks: TaskWithProjectLookupList[] = [];

    dateValidator: Validator = {
        isValid: null,
        errors: []
    };

    projectTaskValidator: Validator = {
        isValid: null,
        errors: []
    };

    activityValidator: Validator = {
        isValid: null,
        errors: []
    };

    identifierValidator: Validator = {
        isValid: null,
        errors: []
    };

    durationValidator: Validator = {
        isValid: null,
        errors: []
    };

    @Watch('performedWorkId')
    refreshDetails(newVal: boolean) {
        if (newVal) {
            this.loadPerformedWork(this.performedWorkId);
        }
    }

    @Watch('performedWork.duration')
    checkDurationFormat(newVal: number) {
        const newValString = newVal.toString();
        if (newValString.includes('.') && newValString.split('.')[1].length > 2) {
            const errors = [];
            errors.push(this.$t('errors.durationFormatInvalid') as string);
            handleValidationErrors(this, errors, this.durationValidator);
        }
        else {
            this.durationValidator = {
                isValid: null,
                errors: []
            };
        }
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.performedWorkDate = DateTime.getCurrentDateTime(DateTime.formats.date).startOf('day').utcOffset(0, true);
        this.loadTasks();
        //this.getLatestEntry();
        this.btnSaveAsNew.classList.remove('btn', 'btn-secondary');
    }

    clearValidators() {
        this.dateValidator = {
            isValid: null,
            errors: []
        };

        this.projectTaskValidator = {
            isValid: null,
            errors: []
        };

        this.activityValidator = {
            isValid: null,
            errors: []
        };

        this.identifierValidator = {
            isValid: null,
            errors: []
        };

        this.durationValidator = {
            isValid: null,
            errors: []
        };
    }

    async loadTasks() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `taskswithprojectlookup`,
                method: 'GET'
            });

            this.tasks = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadPerformedWork(performedWorkId: string) {
        if (performedWorkId.length == 0) {
            return;
        }

        this.isBusy = true;

        DateTime.setLocale(this.$i18n.locale);

        try {
            const response = await AxiosService.request<PerformedWorkData>({
                url: `performedwork/${performedWorkId}`,
                method: 'GET'
            });

            this.performedWork = response.data;
            this.performedWorkDate = response.data.date;
            if (this.action == 'COPY') {
                this.performedWork.id = null;
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async getLatestEntry() {
        this.isBusy = true;

        DateTime.setLocale(this.$i18n.locale);

        try {
            const response = await AxiosService.request<PerformedWorkData>({
                url: `performedwork/latestEntry`,
                method: 'GET'
            });

            if (response.status === 204) return;

            this.performedWork = response.data;
            this.performedWork.id = null;
            this.performedWork.date = this.performedWorkDate;
            this.performedWork.isActive = true;

            const selectedTask = this.tasks.find((task) => task.id === this.performedWork.taskId);

            if (selectedTask) {
                this.performedWork.projectId = selectedTask.project.id;
            }
            else {
                this.performedWork.taskId = null;
                this.performedWork.projectId = null;
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    resetForm() {
        this.performedWork.duration = 0;
        this.performedWork.activity = null;
        this.performedWork.identifier = null;
    }

    onSaveAsNewClick() {
        this.performedWork.id = null;
        this.pwDropdown.hide();
    }

    async onSubmit(e: Event) { // eslint-disable-line @typescript-eslint/no-unused-vars
        if (this.isBusySave) return;

        this.isBusy = true;
        this.isBusySave = true;

        this.clearValidators();

        const selectedTask = this.tasks.find((task) => task.id === this.performedWork.taskId);

        if (selectedTask) {
            this.performedWork.projectId = selectedTask.project.id;
        }
        else {
            this.performedWork.taskId = null;
        }
        this.performedWork.date = this.performedWorkDate;

        const identifier = this.performedWork.identifier?.trim() as string | null;
        if (!identifier) {
            this.performedWork.identifier = null;
        }
        else {
            this.performedWork.identifier = identifier;
        }

        try {
            await AxiosService.request<boolean>({
                url: `performedwork`,
                method: 'POST',
                data: this.performedWork
            });

            this.$root.$bvToast.toast(this.$t('toaster.performedWorkSaved') as string, {
                title: this.$t('toaster.savePerformedWorkTitle') as string,
                autoHideDelay: Configuration.ToasterAutoHideDelay,
                appendToast: true,
                variant: Configuration.ToasterVariantSuccess,
                toaster: Configuration.ToasterPosition
            });
            this.performedWork.id = null;
            this.resetForm();
            this.$emit('performed-work-saved', true);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    case 400:
                        handleValidationErrors(this, error.response.data.errors.Date, this.dateValidator);
                        handleValidationErrors(this, error.response.data.errors.ProjectId, this.projectTaskValidator);
                        handleValidationErrors(this, error.response.data.errors.TaskId, this.projectTaskValidator);
                        handleValidationErrors(this, error.response.data.errors.Duration, this.durationValidator);
                        handleValidationErrors(this, error.response.data.errors.Activity, this.activityValidator);
                        handleValidationErrors(this, error.response.data.errors.Identifier, this.identifierValidator);
                        return;
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
            this.isBusySave = false;
        }
    }

    onChangeDate(e: moment.Moment) {
        this.performedWork.date = e;
        this.performedWorkDate = e;
    }
}

interface PerformedWorkData {
    id: string | null;
    sequenceId: number;
    taskId: string | null;
    projectId: string | null;
    date: moment.Moment | undefined;
    activity: string | null;
    identifier: string | null;
    duration: number;
    isActive: boolean;
}

interface EntityList {
    records: TaskWithProjectLookupList[];
}

interface TaskWithProjectLookupList {
    id: string | null;
    name: string | null;
    project: EntityReference;
    projectManager: EntityReference;
}
